import { render, staticRenderFns } from "./ElasticTextarea.vue?vue&type=template&id=22d03130&scoped=true&"
import script from "./ElasticTextarea.vue?vue&type=script&lang=js&"
export * from "./ElasticTextarea.vue?vue&type=script&lang=js&"
import style0 from "./ElasticTextarea.vue?vue&type=style&index=0&id=22d03130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d03130",
  null
  
)

export default component.exports